import { FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { BaseCheckbox, BaseDateTimePicker, BaseInput, FormBodyContainer } from 'wbs-components-lib';

import { BetEventFormProps } from './types';
import { betEventFormValidationSchema } from './validationSchema';

import { FileSelector } from 'v2/components/fileSystem/fileSelector/FileSelector';

export const BetEventForm: FC<BetEventFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting = false,
  submitButtonCaption = 'Create',
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={betEventFormValidationSchema}
    enableReinitialize
  >
    {({ submitForm, values, handleChange, handleBlur, setFieldValue, errors, touched }) => {
      const {
        name: nameValue,
        streamLink: streamLinkValue,
        imageId: imageIdValue,
        startDate: startDateValue,
        actionText: actionTextValue,
        hasSingleBet: hasSingleBetValue,
      } = values;
      const {
        name: nameError,
        streamLink: streamLinkError,
        startDate: startDateError,
        actionText: actionTextError,
      } = errors;
      const {
        name: isNameTouched,
        streamLink: isStreamLinkTouched,
        startDate: isStartDateTouched,
        actionText: isActionTextTouched,
      } = touched;

      const onSubmit = async () => {
        await submitForm();
      };

      const isNameError = isNameTouched && !!nameError;
      const isStreamLinkError = isStreamLinkTouched && !!streamLinkError;
      const isStartDateError = isStartDateTouched && !!startDateError;
      const isActionTextError = isActionTextTouched && !!actionTextError;

      const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

      return (
        <FormBodyContainer
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
          submitButtonCaption={submitButtonCaption}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
        >
          <BaseInput
            helperText={isNameError && nameError}
            label="Enter name"
            id="name"
            name="name"
            caption="Name"
            value={nameValue}
            onBlur={handleBlur}
            onChange={handleChange}
            error={isNameError}
          />
          <BaseInput
            helperText={isStreamLinkError && streamLinkError}
            label="Enter link"
            id="streamLink"
            name="streamLink"
            caption="Stream Link"
            value={streamLinkValue}
            onBlur={handleBlur}
            onChange={handleChange}
            error={isStreamLinkError}
          />
          <BaseCheckbox
            id="hasSingleBet"
            name="hasSingleBet"
            checked={hasSingleBetValue}
            title="Has Single Bet"
            onChange={handleChange}
          />
          <BaseDateTimePicker
            id="startDate"
            name="startDate"
            errorMessage={isStartDateError ? (startDateError as string) : undefined}
            caption="Start Date"
            onBlur={handleBlur}
            value={startDateValue}
            onChange={(value) => setFieldValue('startDate', value)}
          />
          <FileSelector
            label="Bet Event Image"
            value={imageIdValue ?? ''}
            onSelect={(value) => setFieldValue('imageId', value)}
            required
          />
          <BaseInput
            helperText={isActionTextError && actionTextError}
            label="Enter button text"
            id="actionText"
            name="actionText"
            caption="Button text"
            value={actionTextValue}
            onBlur={handleBlur}
            onChange={handleChange}
            error={isActionTextError}
          />
        </FormBodyContainer>
      );
    }}
  </Formik>
);
